// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"---------packages-corgi-x-src-styles-visuallyHidden-module__visuallyHidden"};